import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { TimeSheetResponse } from '../models/TimeSheet';

@Injectable({
  providedIn: 'root',
})
export class AdminService {
  candidates: any;
  constructor(private http: HttpClient) {}

  getAdmins(
    pageNumber: string = '1',
    query: string = '',
    pageSize: string = '10'
  ): Observable<any> {
    return this.http.get(
      `${environment.apiConfig.uri}/admin/Candidates/GetAdminsPaginatedList?pageNumber=` +
        pageNumber +
        '&query=' +
        query +
        '&pagesize=' +
        pageSize
    );
  }

  getTimeSheets(): Observable<TimeSheetResponse> {
    return this.http.get<TimeSheetResponse>(
      `${environment.apiConfig.uri}/Admin/Gettimesheets`
    );
  }

  getAllTasks(): Observable<any> {
    return this.http.get(`${environment.apiConfig.uri}/Admin/GetAllTasks`);
  }

  addProjectTimeSheet(payload: any): Observable<any> {
    return this.http.post(
      `${environment.apiConfig.uri}/Admin/addProjectTimeSheet`,
      payload
    );
  }

  updateProjectTimeSheet(id:any,payload: any): Observable<any> {
    return this.http.put(
      `${environment.apiConfig.uri}/Admin/updateProjectTimeSheet?id=${id}`,
      payload
    );
  }

  deleteTask(taskId: number): Observable<any> {
    return this.http.delete(
      `${environment.apiConfig.uri}/Admin/DeleteTask?taskId=${taskId}`
    );
  }

  deleteProjectTimeSheet(projectId: number): Observable<any> {
    return this.http.delete(
      `${environment.apiConfig.uri}/Admin/DeleteProjectTimeSheet?id=${projectId}`
    );
  }

  deleteAllProjectTimeSheets(): Observable<any> {
    return this.http.delete(
      `${environment.apiConfig.uri}/Admin/DeleteAllProjectTimeSheets`
    );
  }

  getDepartments(): Observable<any> {
    return this.http.get(`${environment.apiConfig.uri}/Admin/getDepartments`);
  }

  getTasksByDepartment(departmentName: string): Observable<any> {
    const params = new HttpParams().set('departmentName', departmentName);
    return this.http.get(`${environment.apiConfig.uri}/Admin/getTasksByDepartment`, { params });
  }

  addTask(departmentName: string, taskName: string): Observable<any> {
    const encodedDept = encodeURIComponent(departmentName);
    const encodedTask = encodeURIComponent(taskName);
    const url = `${environment.apiConfig.uri}/Admin/addTask?departmentName=${encodedDept}&taskName=${encodedTask}`;
    return this.http.post(url, null);
  }
}